import React from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { HOMEPAGE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsHomePage';

import { CAR_PRIZE_JAN_26_URL } from './CarPrizeJan2026.helpers';
import LocalTexts from './CarPrizeJan2026.texts.json';

import styles from './CarPrizeJan2026.scss';

const LocalT = new MDText(LocalTexts);

const TEXT = {
  content: LocalT.translate('banner.content'),
  emoji: LocalT.translate('banner.emoji'),
};

export const CarPrizeJan2026Banner = () => (
  <Link
    data-thc-style-override
    className={styles.banner}
    onClick={() => HOMEPAGE_SNOW_PLOW_EVENTS.CAR_PRIZE_CLICKED(`${TEXT.content}`)}
    to={CAR_PRIZE_JAN_26_URL}
  >
    <span>{TEXT.emoji}</span>{TEXT.content}
  </Link>
);
